import { Outlet } from "react-router-dom";
import { Header } from "@/components/layout/header";
import { ErrorBoundary } from "@/components/error-boundary";

export default function AppLayout() {
  return (
    <div className="flex flex-col h-screen bg-surface-100">
      <Header />
      <main className="flex-1 overflow-auto">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
